import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useCallback } from "react";
import { ApolloError } from "@apollo/client";
import {
  Mutation,
  PspPaymentCreateTransactionInput,
} from "src/types/graphql.d";

export interface PspPaymentCreateTransactionData {
  pspPaymentCreateTransaction: Mutation["pspPaymentCreateTransaction"];
}
interface PspPaymentCreateTransactionVars {
  data: PspPaymentCreateTransactionInput;
}

interface PspPaymentCreateTransactionHook {
  data?: PspPaymentCreateTransactionData | null;
  loading: boolean;
  error?: ApolloError;
  pspPaymentCreateTransaction: (dataVariable: {
    payment_id: string;
    cart_id: string;
    return_url: string;
    payment_method: string;
    card_token: string | undefined;
    apple_pay_token: string | undefined;
  }) => void;
}

const PSP_PAYMENT_CREATE_TRANSACTION = gql`
  mutation pspPaymentCreateTransaction(
    $data: PspPaymentCreateTransactionInput!
  ) {
    pspPaymentCreateTransaction(data: $data) {
      payment_id
      checkout_url
    }
  }
`;

const usePspPaymentCreateTransaction = ({
  refetchQueries = [],
  onCompleted,
  onError,
}: {
  refetchQueries?: string[];
  onCompleted?: (
    pspPaymentCreateTransactionData: PspPaymentCreateTransactionData
  ) => void;
  onError?: (error: ApolloError) => void;
} = {}): PspPaymentCreateTransactionHook => {
  const [pspPaymentCreateTransactionMutation, { data, loading, error }] =
    useMutation<
      PspPaymentCreateTransactionData,
      PspPaymentCreateTransactionVars
    >(PSP_PAYMENT_CREATE_TRANSACTION, {
      refetchQueries,
      onCompleted,
      onError,
    });
  const pspPaymentCreateTransaction = useCallback(
    (dataVariable: {
      payment_id: string;
      cart_id: string;
      return_url: string;
      payment_method: string;
      card_token: string | undefined;
      apple_pay_token: string | undefined;
    }) =>
      pspPaymentCreateTransactionMutation({
        variables: {
          data: {
            ...dataVariable,
          },
        },
      }),
    [pspPaymentCreateTransactionMutation]
  );

  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  return { pspPaymentCreateTransaction, data, loading, error };
};

export { usePspPaymentCreateTransaction };
